export default function Footer() {
  const footerLinks = [
    {
      title: '视频品牌',
      items: ['91视频', '97视频', '51视频网站', '数字视频平台'],
    },
    {
      title: '服务保障',
      items: ['免费高清', '流畅不卡顿', '海量资源', '安全浏览'],
    },
    {
      title: '关于平台',
      items: ['平台介绍', '内容准则', '版权声明', '加入我们'],
    },
  ];

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                宅男视频
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              宅男视频是一个汇聚91视频、97视频等数字品牌在线入口的数字视频平台，提供免费高清播放服务，覆盖51视频网站及数字视频平台海量资源，致力为用户带来流畅不缓冲的在线观看体验。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#hero"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-background-300 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/40">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 宅男视频 - 91视频97视频在线观看与免费高清数字视频平台 版权所有
            </p>
            <div className="flex items-center gap-6">
              <span className="text-xs text-background-500">合作伙伴</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}